import { render, staticRenderFns } from "./registerOfFacilities.vue?vue&type=template&id=3631b2fa&scoped=true"
import script from "./registerOfFacilities.vue?vue&type=script&lang=js"
export * from "./registerOfFacilities.vue?vue&type=script&lang=js"
import style0 from "./registerOfFacilities.vue?vue&type=style&index=0&id=3631b2fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3631b2fa",
  null
  
)

export default component.exports